import React, { useMemo } from "react";
import { useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import more from "highcharts/highcharts-more";
import * as HighchartsDrillDownModule from "highcharts/modules/drilldown";
import TitleBar from "components/TitleBar";
import ProcurementServiceListPopUp from "./procurementServiceListPopUp";

if (typeof more === "function") {
  more(Highcharts);
}

const drilldownModule = HighchartsDrillDownModule.default;
if (typeof drilldownModule === "function") {
  drilldownModule(Highcharts);
}

// const items = [
//   { label: "Awarded", count: 8, color: "#C0CA33" },
//   {
//     label: "In-Progress",
//     count: 2,
//     color: "#FF9800",
//     isDrill: true,
//     id: "in_progress",
//   },
//   { label: "Not Started", count: 12, color: "#9C27B0" },
//   // { label: "Delayed (In-Progress)", count: "01", color: "#D81B60" },
// ];




const drilldownItems = [
  {
    id: "in_progress",
    name: "",
    data: [
      {
        name: "In-Progress",
        y: 2,
        color: "#FF9800",
      },
      {
        name: "Delayed (In-Progress)",
        y: 0,
        color: "#D81B60",
      },
    ],
  },
];

const getCenterTemplate = (val) => `
  <div style="
    display: flex; 
    flex-direction: column; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    pointer-events: none;
  ">
    <span style="
      font-size: 24px; 
      font-weight: 700; 
      font-family: 'Outfit', sans-serif; 
      color: #000000;
      line-height: 1;
    ">
      ${val}
    </span>
  </div>
`;

const ServicesStatus = ({ data, isLoading, isError }) => {
  const [isViewTracker, setIsViewTracker] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);



  const colorPlate = ["#C0CA33", "#FF9800", "#9C27B0", "#D81B60"]


 const items =
  data?.statusBreakdown
    ?.filter(item => item?.statusName?.trim())
    ?.map((item, ind) => ({
      label: item.statusName,
      count: item?.count ?? 0,
      color: colorPlate[ind]
    })) || [];

  // const totalCount = items.reduce((acc, curr) => acc + curr.count, 0);
  const totalCount = data?.total || 0;
  const handleCategoryClick = (categoryName) => {

    setSelectedCategory(categoryName);
    setIsViewTracker(true);
  };

  const handleClose = () => {
    setIsViewTracker(false);
    setSelectedCategory(null);
  };

  const options = useMemo(() => {
    return {
      chart: {
        type: "pie",
        height: 250,
        backgroundColor: "transparent",
        events: {
          drilldown: function (e) {
            const subTotal = e.seriesOptions.data.reduce(
              (acc, p) => acc + (p.y || 0),
              0
            );

            this.setTitle({
              text: getCenterTemplate(subTotal),
            });
          },
          drillup: function () {
            this.setTitle({
              text: getCenterTemplate(totalCount),
            });
          },
        },
        margin: 0,
      },

      title: {
        text: getCenterTemplate(totalCount),
        align: "center",
        verticalAlign: "middle",
        useHTML: true,
        y: 25,
      },

      tooltip: {
        enabled: true,
      },

      plotOptions: {
        pie: {
          innerSize: "75%",
          size: "100%",
          borderWidth: 0,
          borderRadius: 0,
          borderColor: "#fff",
          dataLabels: {
            enabled: false,
          },
          cursor: "pointer",
          point: {
            events: {
              click: function (event) {
                handleCategoryClick(this.name);
              }
            }
          }
        },
      },

      series: [
        {
          name: "Services",
          data: items.map((item, ind) => ({
            y: Number(item.count) || 0,
            name: item.label,
            color: colorPlate[ind],
            drilldown: item.isDrill ? item.id : null,
          })),
        },
      ],

      drilldown: {
        series: drilldownItems,
      },

      credits: {
        enabled: false,
      },

      legend: {
        enabled: false,
      },
    };
  }, [items, totalCount]);

  return (
    <>
      <Box>
        <TitleBar title={"Procurement Status - Services"} description={" Procurement Status Overview for Services"} />
        {/* <Box sx={{ pl: 3.5, pb: 0, pt: 2 }}>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 400,
            color: "#010814",
            fontFamily: "Outfit, sans-serif",
            lineHeight: "24px",
            verticalAlign: "middle",
          }}
        >
          Average RFQ to Work-Order time
        </Typography>
        <Typography
          sx={{
            fontSize: "28px",
            fontWeight: 400,
            color: "#010814",
            fontFamily: "Outfit, sans-serif",
            lineHeight: "36px",
            verticalAlign: "middle",
          }}
        >
          28 Days
        </Typography>
      </Box> */}
        <Grid
          container
          sx={{ alignItems: "center", justifyContent: "space-between", px: 2 }}
          spacing={1}
        >
          <Grid size={{ md: 6 }}>
            <Stack
              spacing={2.4}
              sx={{
                pt: 1.5,
                pl: 1.5,
                pb: 1.5,
                maxHeight: "310px",
                minHeight: "310px",
                overflowY: "auto",
                justifyContent: "center",
              }}
            >
              {items?.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    border: "1px solid #EAEAEA",
                    borderRadius: "4px",
                    padding: "8px 10px",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        backgroundColor: item?.color,
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#010814",
                        fontFamily: "Outfit, sans-serif",
                        lineHeight: "18px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item?.label}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      minWidth: 40,
                      height: 18,
                      borderRadius: "5px",
                      backgroundColor: "#E7E7EB",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#433F5E",
                      fontFamily: "Outfit, sans-serif",
                    }}
                  >
                    {String(item?.count).padStart(2, "0")}
                  </Box>
                </Box>
              ))}
            </Stack>
          </Grid>
          <Grid size={{ md: 5.5 }}>
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
            //allowChartUpdate={true}
            />
          </Grid>
        </Grid>
      </Box>
      {isViewTracker && (
        <ProcurementServiceListPopUp
          header="Procurement Status - Services"
          open={isViewTracker}
          handleClose={handleClose}
          data={{ Status: selectedCategory }}

        />
      )}
    </>
  );
};

export default ServicesStatus;
